import React from "react";

function Button({ btnText, color, onClick }) {

  const btnBaseClass = `px-4 py-2 border border-transparent text-xl
    rounded transition duration-150 ease-in-out focus:outline-none md:px-6`

  // customize styling based on button colors
  let btnClass = color === 'dark' ? 
    `${btnBaseClass} bg-indigo-600 text-white hover:bg-indigo-700` 
    : `${btnBaseClass} bg-indigo-100 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-200 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border border-transparent`

  return (
    <>
      <button onClick={onClick} className={btnClass}>
        {btnText}
      </button>
    </>
  )
}

export default Button;
